import React, { useState } from 'react';
import cn from 'classnames';
import Label from "../../../Label";
import BodyText from "../../../../ui/Typography/texts/BodyText";
import { trackOnSizeGuideRange } from '../../helpers/tracking';
import styles from './SizeRangeTabContent.module.scss';
const NUMBER_OF_SIZES_SHOWN = 3;
// This function extracts the time unit of the size range
const getSizeRangeTimeUnit = (sizeRange) => {
    var _a;
    // Captures the time units in the string e.g. "9 M" or "18月"
    const timeUnitRegex = /[a-zA-ZЛ月年齢]{1,2}/;
    const timeUnit = sizeRange.length === 2 && ((_a = sizeRange[1].match(timeUnitRegex)) === null || _a === void 0 ? void 0 : _a[0]);
    return timeUnit || null;
};
const SizeRangeTabContent = ({ tableData, isBossPDP }) => {
    const calculateSizeRangeButtonValues = (sizeArray, numberOfSizesOnTheLastButton, numberOfButtons) => {
        const buttonsArray = [];
        const sizeArrayLength = sizeArray.length;
        // Create the buttons
        let index = 0;
        // Calculate which values should be on the Buttons
        while (index < numberOfButtons) {
            let buttonText = '';
            if (index < numberOfButtons ||
                (index === numberOfButtons - 1 && numberOfSizesOnTheLastButton === NUMBER_OF_SIZES_SHOWN)) {
                const firstSizeRangeSplit = sizeArray[NUMBER_OF_SIZES_SHOWN * index].split('-');
                const secondSizeRangeSplit = index < numberOfButtons - 1
                    ? sizeArray[NUMBER_OF_SIZES_SHOWN * index + (NUMBER_OF_SIZES_SHOWN - 1)].split('-')
                    : sizeArray[sizeArrayLength - 1].split('-');
                const firstValueTimeUnit = getSizeRangeTimeUnit(firstSizeRangeSplit);
                const secondValueTimeUnit = getSizeRangeTimeUnit(secondSizeRangeSplit);
                const firstSizeRangeValue = firstSizeRangeSplit.slice(0, 1);
                const secondSizeRangeValue = secondSizeRangeSplit.slice(-1, 2);
                const timeUnitOnBothSizeRange = `${firstSizeRangeValue} ${firstValueTimeUnit}-${secondSizeRangeValue}`;
                const timeUnitOnLastSizeRange = `${firstSizeRangeValue}-${secondSizeRangeValue}`;
                // If size range value are the same, e.g. 30-30, it will display only the first one
                // If time units are different, they will be added in the buttonText. e.g. 9 M - 2 Y
                buttonText =
                    firstSizeRangeValue[0] === secondSizeRangeValue[0]
                        ? `${firstSizeRangeValue}`
                        : firstValueTimeUnit !== secondValueTimeUnit
                            ? timeUnitOnBothSizeRange
                            : timeUnitOnLastSizeRange;
            }
            else if (index === numberOfButtons - 1 && numberOfSizesOnTheLastButton === 1) {
                buttonText = `${sizeArray[sizeArrayLength - 1]}`;
            }
            else {
                buttonText = `${sizeArray[NUMBER_OF_SIZES_SHOWN * index]}-${sizeArray[sizeArrayLength - 1]}`;
            }
            buttonsArray.push(buttonText);
            index += 1;
        }
        // Return the list of buttons
        return buttonsArray;
    };
    // Create the ShowSizesButtons
    const getSizeRangeButtonValues = () => {
        // Get the Array of sizes
        // Throw away the first Child
        const sizeArray = tableData[0] && tableData[0].sizeTableData[0] && tableData[0].sizeTableData[0].row
            ? tableData[0].sizeTableData[0].row.slice(1)
            : [];
        // Calculate how many Buttons it will have
        if (sizeArray.length > 0) {
            const sizeArrayLength = sizeArray.length;
            const numberOfSizesOnTheLastButton = sizeArrayLength % NUMBER_OF_SIZES_SHOWN || NUMBER_OF_SIZES_SHOWN;
            const numberOfButtons = numberOfSizesOnTheLastButton < NUMBER_OF_SIZES_SHOWN
                ? Math.floor(sizeArrayLength / NUMBER_OF_SIZES_SHOWN) + 1
                : sizeArrayLength / NUMBER_OF_SIZES_SHOWN;
            // Return the list of buttons
            return numberOfButtons > 1
                ? calculateSizeRangeButtonValues(sizeArray, numberOfSizesOnTheLastButton, numberOfButtons)
                : [];
        }
        return [];
    };
    const [button, setButton] = useState(0);
    const [buttonActive, setButtonActive] = useState(Array(getSizeRangeButtonValues().length).fill(true).fill(false, 1));
    const buttonClickHandler = (index) => {
        setButton(index);
        const a = buttonActive.slice();
        a.fill(false);
        a[index] = true;
        setButtonActive(a);
    };
    const showRelevantSizes = (buttonIndex) => (React.createElement("ul", null, tableData.map((sizeTableDataContainer) => (React.createElement(BodyText, { Tag: "li", key: sizeTableDataContainer.title, className: styles.sizeTableListItem },
        React.createElement("table", { className: styles.sizeTable },
            React.createElement("thead", { className: styles.sizeTableHeader },
                React.createElement("tr", null,
                    React.createElement("th", { colSpan: NUMBER_OF_SIZES_SHOWN }, sizeTableDataContainer.title))),
            React.createElement("tbody", null, sizeTableDataContainer.sizeTableData.map((sizeTableRowData) => (React.createElement("tr", { key: `sizeTableRowData-${sizeTableDataContainer.title}-${sizeTableRowData.row[0]}`, className: styles.sizeTableRow },
                React.createElement("td", { className: styles.sizeTableRowCell }, sizeTableRowData.row[0]),
                sizeTableRowData.row
                    .slice(buttonIndex * NUMBER_OF_SIZES_SHOWN + 1, buttonIndex * NUMBER_OF_SIZES_SHOWN + NUMBER_OF_SIZES_SHOWN + 1)
                    .map((size, index) => (React.createElement("td", { 
                    // eslint-disable-next-line react/no-array-index-key
                    key: `sizeTableRowDataCell-${sizeTableDataContainer.title}-${sizeTableRowData.row[0]}-${size}-${index}`, className: styles.sizeTableRowCell }, size)))))))))))));
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: styles.sizeRangeButtons }, getSizeRangeButtonValues().map((label, index) => (React.createElement("li", { key: `sizeRangeButton-${label}`, className: styles.sizeRanges },
            React.createElement("button", { type: "button", onClick: () => {
                    trackOnSizeGuideRange(isBossPDP);
                    buttonClickHandler(index);
                }, className: cn(styles.sizeRangeButton, buttonActive[index] && styles.active) },
                React.createElement(Label, { copyKey: label })))))),
        showRelevantSizes(button)));
};
export default SizeRangeTabContent;
//# sourceMappingURL=SizeRangeTabContent.js.map